export default {"src":"/frontend-static/_next/static/media/star-chat.b22651ff.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};